import { useMemo } from 'react'
import { useAccount } from 'wagmi'
import { toBigNumber, formatFormAmount } from '~/utils/numbers'
import { StyledBalanceContainer } from './styled'
import MaxButton from '~/components/Button/MaxButton'
import { useTranslation } from 'react-i18next'
import Tooltip from '~/components/Tooltip'
import { useSpotSwapPair } from '~/state/dex/hooks'
import { AddressZero } from '@ethersproject/constants'
import { useNativeTokenBalance, useTokenBalance } from '~/state/wallet/hooks'
import { useIsInIframe } from '~/hooks'

interface LabelFromProps {
  gasFee: string | undefined
  onMax: () => void
}

const LabelFrom: React.FC<LabelFromProps> = ({ gasFee, onMax }) => {
  const { address: account } = useAccount()
  const isWalletConnected = !!account
  const { t } = useTranslation()
  const isInIframe = useIsInIframe()
  const [inputToken] = useSpotSwapPair()
  const isSellETH = inputToken?.address === AddressZero

  const ethBalance = useNativeTokenBalance()
  const tokenBalance = useTokenBalance({
    address: inputToken?.address,
    decimals: inputToken?.decimals,
    name: '',
    symbol: inputToken?.symbol,
  })

  const ethBalanceStr = ethBalance?.toDecimalsFixed(ethBalance.decimals)
  const tokenBalanceStr = tokenBalance?.toDecimalsFixed(inputToken?.decimals)

  const balance = isSellETH ? ethBalanceStr : tokenBalanceStr

  const maxTradableETHBalance = useMemo(() => {
    let result = ethBalanceStr
    if (isSellETH) {
      const calcBalance = toBigNumber(ethBalanceStr).minus(gasFee ?? 0)
      if (calcBalance.lt(0)) {
        result = '0'
      } else result = calcBalance.toFixed()
    }
    return result
  }, [ethBalanceStr, gasFee])

  return (
    <StyledBalanceContainer isInIframe={isInIframe}>
      {isWalletConnected && (
        <div>
          <span className="amount">
            {t('balance')}: {formatFormAmount(balance, 4)} {inputToken?.symbol}
          </span>
          {Number(balance) !== 0 ? (
            isSellETH ? (
              <Tooltip
                placement="right"
                title={t('spotswap_max_btn_tooltip')}
                tooltipTitle={t('spotswap_max_btn_tooltip_title')}
                tooltipTitleValue={`${formatFormAmount(
                  maxTradableETHBalance,
                )} ETH`}
                trigger="hover"
              >
                <MaxButton handleClick={onMax} />
              </Tooltip>
            ) : (
              <MaxButton handleClick={onMax} />
            )
          ) : null}
        </div>
      )}
    </StyledBalanceContainer>
  )
}

export default LabelFrom
